import React from "react";
import { Row, Col, Form } from "react-bootstrap";

const CheckboxList = ({
  items,
  checkList,
  clickCheckBox,
  context,
  permissionKey,
  onCheck,
}) => (
  <Row>
    {items.map((item) => (
      <Col md="4" xs="12" key={item?.itemDetailsId}>
        <Form.Group className="mb-3">
          <Form.Check
            style={{ marginRight: "15px" }}
            label={item?.itemName}
            type="checkbox"
            aria-label="Checkbox"
            disabled={!context.permissionsList?.includes(permissionKey)}
            checked={
              clickCheckBox
                ? !!checkList?.includes(item?.itemDetailsId)
                : !!item?.isActive
            }
            onClick={(e) => onCheck(e, item)}
          />
        </Form.Group>
      </Col>
    ))}
  </Row>
);

export default CheckboxList;